<template lang="pug">

   .slide
      img(style="display:none" ref="pattern" src="~assets/ui/pattern2.png")
      canvas(ref="cvs")
      canvas(ref="canvas")
      .tutor-content(:class="{'active': active}")

        //.copy1
          .line1 上下滑动屏幕
          .line2 切换景点
        //waveline


</template>

<script>
import BgPattern from 'src/components/vca/widgets/BgPattern'
const json1 = require('src/assets/tutorial/tutor3.txt')
const png1 = require('src/assets/tutorial/tutor3.png')
const atlas1 = require('src/assets/tutorial/tutor3.atlas')
const json2 = require('src/assets/tutorial/tutor1.txt')
const png2 = require('src/assets/tutorial/tutor1.png')
const atlas2 = require('src/assets/tutorial/tutor1.atlas')
const json3 = require('src/assets/tutorial/tutor2.txt')
const png3 = require('src/assets/tutorial/tutor2.png')
const atlas3 = require('src/assets/tutorial/tutor2.atlas')
const json4 = require('src/assets/tutorial/tutor4.txt')
const png4 = require('src/assets/tutorial/tutor4.png')
const atlas4 = require('src/assets/tutorial/tutor4.atlas')
import Waveline from 'src/components/vca/widgets/Waveline'
import Raf from 'src/helpers/Raf'
import { mapState, mapMutations } from 'vuex'
import { spine } from 'src/helpers/spine-webgl'
export default {

  name: 'Slide3',
  props: {
    active: {
      default: false
    },
    idx: {

    }

  },
  components: {
    Waveline,
    BgPattern
  },
  data() {
    return {
      lastFrameTime: Date.now() / 1000,
      canvas: null,
      shader: null,
      batcher: null,
      gl: null,
      mvp: new spine.webgl.Matrix4(),
      assetManager: null,
      skeletonRenderer: null,
      debugRenderer: null,
      shapes: null,
      skeletons: [],
      activeSkeleton: "skeleton",
      swirlEffect: new spine.SwirlEffect(0),
      jitterEffect: new spine.JitterEffect(20, 20),
      swirlTime: 0,
      tex1: png1,
      atl1: atlas1,
      jso1: json1,
      tex2: png2,
      atl2: atlas2,
      jso2: json2,
      tex3: png3,
      atl3: atlas3,
      jso3: json3,
      tex4: png4,
      atl4: atlas4,
      jso4: json4,


      ofsSpeed: 0.08,
      ofs: 0,
      cx: 0,
      cy: 0,
      cw: 0,
      ch: 0,

      _progress: 0,
      _touchX: 0.5,
      _touchY: 1,
      progress: 0,
      touchX: 0.5,
      touchY: 1,

      pos: [
        {x: -275, y: 80, s: 0.8},
        {x: 20, y: 0, s: 0.95},
        {x: 0, y: 350, s: 1.1},
        {x: 280, y: 250, s: 0.6},
      ],
      copyBoneId: [1, 2, 12, 1],
      copyOfs:[0, 0, 150, 0],
      copyPos:[-37.06, -132.21, 547.06, 723.98],
      scaleF: [0.9, 0.8, 0.75, 1.3]

      //idx: 0
    }
  },
  computed: {
    ...mapState('app', ['tutorProgress', 'tutorTouchX', 'tutorTouchY']),
  },
  mounted() {
    window.Slide33 = this
    this.init()

  },
  beforeDestroy() {
    Raf.remove(this.render)
    Raf.remove(this.textOut)
  },
  methods: {
    stop(){
      Raf.remove(this.render)
    },
    // textOut () {
    //   this.skeletons[3].skeleton.bones[this.copyBoneId[3]].y=this.copyPos[3]+this.copyOfs[3]
    //   this.copyOfs[3] += (-2000 - this.copyOfs[3])*this.ofsSpeed
    //   console.log(this.copyOfs[3])
    //
    // },
    animeOut(){
      //this.ofs -= 5000
      this.stop()
      Raf.add(this.textOut)
      let tl = new TimelineMax({ onComplete: () => {

        } })
      this.tl = tl
      tl.add('start')
        .to(
          this.$refs.canvas,
          0.7,
          {
            x: -window.innerWidth,
            ease: Power2.easeIn,
          },
          `start+=0.6`
        )

    },
    init () {
      window.Slide4 = this
      // Setup canvas and WebGL context. We pass alpha: false to canvas.getContext() so we don't use premultiplied alpha when
      // loading textures. That is handled separately by PolygonBatcher.
      //this.canvas = this.$refs.canvas

      //this.cvs = this.$refs.cvs
      //this.cvs.width = window.innerWidth;
      //this.cvs.height = window.innerHeight;
      //this.ctx = this.cvs.getContext('2d')
      this._progress = 0
      this._touchX = 0.5
      this._touchY = 0.5
      console.log('!!!!', this._progress, this._touchX, this._touchY)
      this.canvas = this.$refs.canvas

      this.canvas.width = window.innerWidth*window.devicePixelRatio;
      this.canvas.height = window.innerHeight*window.devicePixelRatio;
      console.log(this.canvas.width, this.canvas.height, window.devicePixelRatio)
      var config = { alpha: true };
      this.gl = this.canvas.getContext("webgl", config) || this.canvas.getContext("experimental-webgl", config);
      if (!this.gl) {
        alert('WebGL is unavailable.');
        return;
      }

      // Create a simple shader, mesh, model-view-projection matrix and SkeletonRenderer.
      this.shader = spine.webgl.Shader.newTwoColoredTextured(this.gl);
      this.batcher = new spine.webgl.PolygonBatcher(this.gl);
      this.mvp.ortho2d(0, 0, this.canvas.width - 1, this.canvas.height - 1);
      this.skeletonRenderer = new spine.webgl.SkeletonRenderer(this.gl);





      this.pattern = this.loadTexture(this.gl, this.$refs.pattern);



      //this.debugRenderer = new spine.webgl.SkeletonDebugRenderer(this.gl);
      //this.debugRenderer.drawRegionAttachments = true;
      //this.debugRenderer.drawBoundingBoxes = true;
      //this.debugRenderer.drawMeshHull = true;
      //this.debugRenderer.drawMeshTriangles = true;
      //this.debugRenderer.drawPaths = true;
      //this.debugShader = spine.webgl.Shader.newColored(this.gl);
      this.shapes = new spine.webgl.ShapeRenderer(this.gl);
      this.assetManager = new spine.webgl.AssetManager(this.gl);

      // Tell AssetManager to load the resources for each model, including the exported .json file, the .atlas file and the .png
      // file for the atlas. We then wait until all resources are loaded in the load() method.
      this.assetManager.loadText(this.jso1);
      this.assetManager.loadTextureAtlas(this.atl1, this.tex1);

      this.assetManager.loadText(this.jso2);
      this.assetManager.loadTextureAtlas(this.atl2, this.tex2);

      this.assetManager.loadText(this.jso3);
      this.assetManager.loadTextureAtlas(this.atl3, this.tex3);

      this.assetManager.loadText(this.jso4);
      this.assetManager.loadTextureAtlas(this.atl4, this.tex4);

      //console.log(505, this.assetManager)
      Raf.add(this.load)
      //requestAnimationFrame(this.load);
    },
    load () {
      // Wait until the AssetManager has loaded all resources, then load the skeletons.
      if (this.assetManager.isLoadingComplete()) {
        this.skeletons.push(this.loadSkeleton(this.atl1, this.jso1, "skeleton", "animation", true))
        this.skeletons.push(this.loadSkeleton(this.atl2, this.jso2, "skeleton", "animation", true))
        this.skeletons.push(this.loadSkeleton(this.atl3, this.jso3, "skeleton", "animation", true))
        this.skeletons.push(this.loadSkeleton(this.atl4, this.jso4, "skeleton", "animation", true))
        //this.setupUI();
        //requestAnimationFrame(this.render);
        Raf.remove(this.load)
        this.resize()
        this.render()
        if (this.active) {
          Raf.add(this.render)
        }
        //Raf.add(this.render)
      } else {
        //requestAnimationFrame(this.load);
        Raf.add(this.load)
      }
    },
    loadSkeleton (atl, jso, name, initialAnimation, premultipliedAlpha, skin) {
      if (skin === undefined) skin = "default";

      // Load the texture atlas using name.atlas from the AssetManager.
      let atlas = this.assetManager.get(atl);
      //console.log(6055, atlas)
      // Create a AtlasAttachmentLoader that resolves region, mesh, boundingbox and path attachments
      let atlasLoader = new spine.AtlasAttachmentLoader(atlas);

      // Create a SkeletonJson instance for parsing the .json file.
      var skeletonJson = new spine.SkeletonJson(atlasLoader);

      //console.log(405,atlasLoader, skeletonJson)

      // Set the scale to apply during parsing, parse the file, and create a new skeleton.
      //console.log(608, this.assetManager.get(this.jso))
      var skeletonData = skeletonJson.readSkeletonData(this.assetManager.get(jso));
      var skeleton = new spine.Skeleton(skeletonData);
      skeleton.setSkinByName(skin);
      var bounds = this.calculateBounds(skeleton);

      // Create an AnimationState, and set the initial animation in looping mode.
      let animationStateData = new spine.AnimationStateData(skeleton.data);
      var animationState = new spine.AnimationState(animationStateData);

      animationState.setAnimation(0, initialAnimation, true);
      animationState.addListener({
        // start: function(track) {
        //   console.log("Animation on track " + track.trackIndex + " started");
        // },
        interrupt: function(track) {
          console.log("Animation on track " + track.trackIndex + " interrupted");
          track.reset()
        },

      })

      // Pack everything up and return to caller.
      return { skeleton: skeleton, state: animationState, bounds: bounds, premultipliedAlpha: premultipliedAlpha };
    },

    calculateBounds(skeleton) {
      skeleton.setToSetupPose();
      skeleton.updateWorldTransform();
      var offset = new spine.Vector2();
      var size = new spine.Vector2();
      skeleton.getBounds(offset, size, []);
      return { offset: offset, size: size };
    },
    loadTexture(gl, img) {
      const texture = gl.createTexture();
      gl.bindTexture(gl.TEXTURE_2D, texture);

      // Because images have to be download over the internet
      // they might take a moment until they are ready.
      // Until then put a single pixel in the texture so we can
      // use it immediately. When the image has finished downloading
      // we'll update the texture with the contents of the image.
      const level = 0;
      const internalFormat = gl.RGBA;
      const width = 1;
      const height = 1;
      const border = 0;
      const srcFormat = gl.RGBA;
      const srcType = gl.UNSIGNED_BYTE;
      const pixel = new Uint8Array([0, 0, 255, 255]);  // opaque blue
      gl.texImage2D(gl.TEXTURE_2D, level, internalFormat,
        width, height, border, srcFormat, srcType,
        pixel);

      const image = img;
      image.onload = () => {
        gl.bindTexture(gl.TEXTURE_2D, texture);
        gl.texImage2D(gl.TEXTURE_2D, level, internalFormat,
          srcFormat, srcType, image);

        // WebGL1 has different requirements for power of 2 images
        // vs non power of 2 images so check if the image is a
        // power of 2 in both dimensions.
        if (this.isPowerOf2(image.width) && this.isPowerOf2(image.height)) {
          // Yes, it's a power of 2. Generate mips.
          gl.generateMipmap(gl.TEXTURE_2D);
        } else {
          // No, it's not a power of 2. Turn off mips and set
          // wrapping to clamp to edge
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE);
          gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);
        }
      };

      return texture;
    },

    isPowerOf2(value) {
      return (value & (value - 1)) == 0;
    },

    render () {
      var now = Date.now() / 1000;
      var delta = now - this.lastFrameTime;
      this.lastFrameTime = now;

      // Update the MVP matrix to adjust for canvas size changes
      //this.resize();
      //this.posUpdate()
      //this.gl.clearColor(225/255, 81/255, 37/255, 1);
      //this.gl.clear(this.gl.COLOR_BUFFER_BIT);

      // Apply the animation state based on the delta time.
      var state = this.skeletons[this.idx].state;
      var skeleton = this.skeletons[this.idx].skeleton;

      var bounds = this.skeletons[this.idx].bounds;
      var premultipliedAlpha = this.skeletons[this.idx].premultipliedAlpha;
      state.update(delta);
      state.apply(skeleton);
      skeleton.updateWorldTransform();

      // Bind the shader and set the texture and model-view-projection matrix.
      this.shader.bind();

      // this._progress = this._progress + (this.progress - this._progress) * 0.1
      // //this._touchX = this._touchX + (this.touchX - this._touchX) * 0.1
      // //this._touchY = this._touchY + (this.touchY - this._touchY) * 0.1
      // this._touchX = this._touchX + (this.touchX - this._touchX) * 0.2
      // this._touchY = this._touchY + (this.touchY - this._touchY) * 0.2

      //console.log(this._progress, this._touchX, this._touchY)
      //console.log(this.tutorProgress, this.tutorTouchX, this.tutorTouchY)
      this.shader.setUniformi(spine.webgl.Shader.SAMPLER, 0);
      this.shader.setUniformf('progress', this.tutorProgress);
      //this.shader.setUniformf('time', delta);

      this.shader.setUniformi('idx', this.idx);
      this.shader.setUniform2f('viewResolution', window.innerWidth*window.devicePixelRatio, window.innerHeight*window.devicePixelRatio);
      //this.shader.setUniform2f('textureResolution', 1108, 869);
      this.shader.setUniform2f('touch', this.tutorTouchX, this.tutorTouchY);
      //this.shader.setUniformi('texture', this.pattern);


      this.shader.setUniform4x4f(spine.webgl.Shader.MVP_MATRIX, this.mvp.values);

      // Start the batch and tell the SkeletonRenderer to render the active skeleton.
      this.batcher.begin(this.shader);
      this.skeletonRenderer.vertexEffect = null;


      this.skeletonRenderer.premultipliedAlpha = premultipliedAlpha;
      this.skeletonRenderer.draw(this.batcher, skeleton);
      this.batcher.end();

      this.shader.unbind();

      //console.log(this.shader, this.batcher, this.skeletonRenderer)

      //this.ctx.drawImage(this.canvas, 0, 0, window.innerWidth, window.innerHeight, 0, 0, window.innerWidth, window.innerHeight)

    },


    resize () {
      var w = this.canvas.clientWidth*window.devicePixelRatio;
      var h = this.canvas.clientHeight*window.devicePixelRatio;
      //console.log(w, h)
      var bounds = this.skeletons[this.idx].bounds;
      if (this.canvas.width != w || this.canvas.height != h) {
        this.canvas.width = w;
        this.canvas.height = h;
      }

      // magic
      var centerX = bounds.offset.x + bounds.size.x / 2+this.pos[this.idx].x;
      var centerY = bounds.offset.y + bounds.size.y / 2+this.pos[this.idx].y;
      var scaleX = bounds.size.x / this.canvas.width;
      var scaleY = bounds.size.y / this.canvas.height;
      let scaleYY =  this.canvas.height / 2172
      let scaleXX = this.canvas.width / 1125

      //console.log(this.skeletons[this.idx].skeleton.bones[1])
      //console.log(this.skeletons[this.idx].skeleton.bones[this.copyBoneId[this.idx]].y)
      this.skeletons[this.idx].skeleton.bones[this.copyBoneId[this.idx]].y=this.copyPos[this.idx]+this.copyOfs[this.idx]

      let ratio = window.innerHeight/window.innerWidth

      let s = scaleYY/this.scaleF[this.idx]*0.98
      if (ratio <= 1.8) s = scaleYY/this.scaleF[this.idx]
      console.log(s)
      //console.log(scaleX, scaleY, this.canvas.height, 1/scaleYY, scaleYY, this.canvas.height/2436)
      var scale = this.pos[this.idx].s / s
      //scale = Math.min(scale, scaleYY)
      //if (scale < 1) scale = 1;
      var width = this.canvas.width * scale;
      var height = this.canvas.height * scale;
      this.CX = centerX - width / 2
      this.cy = centerY - height / 2
      this.cw = width
      this.ch = height
      this.cx = this.CX
      this.ofs = this.CX
      this.mvp.ortho2d(this.CX, this.cy, this.cw, this.ch);
      this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    },
    posUpdate () {

      this.cx += (this.ofs - this.cx)*this.ofsSpeed
      //console.log(this.cx, this.CX, this.ofs, this.cx, (this.ofs - this.cx)*this.ofsSpeed)
      this.mvp.ortho2d(this.cx, this.cy, this.cw, this.ch);
      this.gl.viewport(0, 0, this.canvas.width, this.canvas.height);
    },

    setTutorProgress(data){
      this.progress = data
    },
    setSlideOnTouchStart(x, y){
      //console.log(999, x, y)
      this.slideOnTouch = true
      this.touchX = x/window.innerWidth
      this.touchY = y/window.innerHeight
    },
    setSlideOnTouchEnd(y){
      this.slideOnTouch = false
      this.touchX = 0.5
      this.touchY = y/window.innerHeight
    },
    setSlideTouch(x, y){
      //console.log(x, y)
      this.touchX = x/window.innerWidth
      this.touchY = y/window.innerHeight
    },
  },
  watch: {
    idx(val){
      this.resize()
    },
    active(val){
      if (val){
        //console.log('AAAAActive', this.$refs.content)
        //this.skeletons[this.activeSkeleton].state.setAnimation(0, 'animation', true)
        this.ofs = this.CX
        Raf.add(this.render)
        //this.$refs.content.style.transform = 'translate3d(0, 0, 0)'

      } else {
        this.cx = this.CX-2500
        this.render()
        Raf.remove(this.render)
        //console.log('innnnnAAAAActive')
        //this.$refs.content.style.transform = 'translate3d(100%, 0, 0)'
        //this.$refs.content.style.transitionDuration = '0s'
      }
    }
  },
}
</script>

<style lang="sass" scoped>
@import "src/styles/common.sass"
.slide
  //background: linear-gradient(21.07deg, #2752A3 14.22%, #5E80D4 89.05%)
  pointer-events: none
  overflow: hidden
  +full()
  .bg-pattern
    mix-blend-mode: color-burn
  img

    display: block
    object-fit: cover

  canvas
    position: absolute
    +full()
  .tutor-content
    +full()
    //animation: slidein
    //animation-duration: 1s
    //animation-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1)
    //animation-fill-mode: backwards
    //animation-delay: 3.7s
    will-change: transform
    transform: translate3d(100%, 0, 0)
    transition-duration: 1s
    transition-timing-function: cubic-bezier(0.645, 0.045, 0.355, 1)
    transition-property: transform
    &.active
      transform: translate3d(0, 0, 0)



    .copy1


      top: calc(100% - 1.8rem)

      z-index: 100
      position: relative
      width: 100%
      text-align: center
      color: #fff
      line-height: 1.5
      .line1
        font-size: $fs-m
      .line2
        font-size: $fs-xl

    .waveline
      width: 1.2rem
      margin: 0.1rem auto 0 auto
      z-index: 100
      position: relative
      top: calc(100% - 1.8rem)
  .spark
    +full()
  //.tutor-cta
    animation: slideout
    animation-duration: 0.7s
    animation-timing-function: cubic-bezier(0.6, -0.28, 0.735, 0.045)
    animation-fill-mode: both
    animation-delay: 3s
    +full()
    display: flex
    flex-direction: column
    justify-content: center
    align-items: center
    z-index: 110
    .copy
      width: 100%
      text-align: center
      font-size: $fs-m
      color: #fff
      line-height: 1.5
    .waveline
      width: 1.2rem
      margin: 0.1rem auto 0 auto
      z-index: 100
      position: relative
      top: auto


@keyframes slideout
  0%
    transform: translateX(0)
  100%
    transform: translateX(-100%)
@keyframes slidein
  0%
    transform: translateX(100%)
  100%
    transform: translateX(0)
</style>
